import { OrderStatus, OrderType } from '../../graphql/order/models/get-orders.models';

import acceptedIcon from '../../assets/images/order-status/status-accepted.png';
import deliveryIcon from '../../assets/images/order-status/status-waiting.png';
import waitingIcon from '../../assets/images/order-status/status-deliver.png';
import deliveryAcceptedIcon from '../../assets/images/order-status/status-delivery-accepted.png';
import deliveryProcessingIcon from '../../assets/images/order-status/status-delivery-processing.png';
import deliveryConfirmedIcon from '../../assets/images/order-status/status-delivery-confirmed.png';
import fulfilledIcon from '../../assets/images/order-status/checked-green.svg';
import canceledIcon from '../../assets/images/order-status/cancel.svg';

export const getOrderIconByStatus = (
  orderStatus: OrderStatus,
  orderType: OrderType,
): string => {
  const isDelivery = orderType === OrderType.delivery;

  switch (orderStatus) {
    case OrderStatus.new:
    case OrderStatus.contactPatient:
    case OrderStatus.externalOrderCreated:
      return isDelivery ? deliveryAcceptedIcon : acceptedIcon;
    case OrderStatus.processing:
      return isDelivery ? deliveryProcessingIcon : waitingIcon;
    case OrderStatus.confirmed:
      return isDelivery ? deliveryConfirmedIcon : deliveryIcon;
    case OrderStatus.fulfilled:
      return fulfilledIcon;
    default:
      return canceledIcon;
  }
};
